import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ngisense/P4D/Parts4Drive/packages/eve-chat/app/[country]/shop/ShopCountryClient.tsx");
